// extracted by mini-css-extract-plugin
module.exports = {"CompetitionLeaderboardButtons":"style_CompetitionLeaderboardButtons__MrEto","isActive":"style_isActive__26G5l"};